export const invoiceStatuses = {
	UNPAID: "unpaid",
	PAID: "paid",
};
